import { useEffect, useState } from "react";
import GhlEmailPerformanceWidget from "./GhlEmailPerformanceWidget";
import GhlFunnelSyncButton from "./GhlFunnelSyncButton";
import { getGhlEmailStats } from "services/ghl-integration.service";
import { isCustomRangeIncomplete } from "utils/analyticsQueryParams";

const EMAIL_SOURCES = [
  { value: "all", label: "All" },
  { value: "campaign", label: "Campaign" },
  { value: "workflow", label: "Workflow" },
];

export default function EmailAnalyticsSection({ api, filters, refreshKey = 0, onSynced }) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [source, setSource] = useState("all");

  useEffect(() => {
    if (isCustomRangeIncomplete(filters)) {
      setIsLoading(false);
      setData(null);
      setError(null);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await getGhlEmailStats(api, { filters, source });
        if (!cancelled) setData(result);
      } catch {
        if (!cancelled) {
          setData(null);
          setError("Failed to load email metrics.");
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [api, filters?.dateRangeType, filters?.customDateRange?.[0], filters?.customDateRange?.[1], refreshKey, source]);

  return (
    <div>
      <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5">
          {EMAIL_SOURCES.map((option) => {
            const active = source === option.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => setSource(option.value)}
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                  active
                    ? "bg-gray-900 text-white"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </div>
        <GhlFunnelSyncButton api={api} syncType="email" onSynced={onSynced} />
      </div>
      <GhlEmailPerformanceWidget data={data} isLoading={isLoading} error={error} />
    </div>
  );
}
